<template>
    <div class="ve-list-page">
        <div style=" background:white;line-height:30px; border-bottom:2px solid #389;height:38px"> 
            <div style="padding-top:3px;display:flex;width:1400px;line-height:30px ">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px;margin-right:15px;">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>
                <el-select v-model="stfgSet"  size="small" @change="stfgChange" style="width:90px">
                    <el-option :label="$LANG('0321', '所有')" value="ALL"></el-option>
                    <el-option :label="$LANG('2005', '未审核')" value="N"></el-option>
                    <el-option :label="$LANG('1976', '已审核')" value="Y"></el-option>
                </el-select>
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable style="width:130px;  " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <el-select v-model="selparam2" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:130px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
              :table-data="qcData"
              :columnHiddenOption="columnHiddenOption"
              class="custom-table-border"
              v-loading="v_loading"
              :border-around="true"
              :border-x="true"
              :border-y="true"
              :fixed-header="true"
              row-key-field-name="IDSEQ"
              :row-style-option="rowStyleOption"
              :cell-style-option="cellStyleOption"
              :max-height="subHeight"
              :virtual-scroll-option="virtualScrollOption"
              :scroll-width="0"
              :column-width-resize-option="columnWidthResizeOption"
              :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"  
              :cellSelectionOption="{enable: false}"
              id="try_report"
              ref="refqc">
        </ve-table>
        </div>
        <!-- 分页查询 -->
        <div class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-toolbar">
                        <span class="spanRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="gpitem.gpnm=='结论'?160:120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" item.EDCSS=='textarea'?'item-one':'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"   v-else-if="item.DISABLED=='N'&&item.EDCSS=='number'" size="medium" v-model="mainRow[item.FLDNO]" style="width:100%"> </el-input> 
                                <el-checkbox size="medium" :disabled="saveFlag" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-input size="medium" :disabled="saveFlag" @focus="inputBtn('','', item.FLDNO)" v-else-if="item.EDCSS=='button'"   v-model="mainRow[item.FLDNO]" style="width:100%"> </el-input>  
                                <el-select size="medium" :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]" clearable  style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-input resize="none" :disabled="saveFlag" v-else-if="item.EDCSS==='textarea'" type="textarea" :rows="4"  :placeholder="$LANG('1670', '请输入内容')" v-model="mainRow[item.FLDNO]" maxlength="1000" show-word-limit ></el-input>
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>                 
                <div class="one-toolbar">
                    <span class="spanRow"> {{ $LANG('0516', '上传附件') }}</span>
                </div>
                <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :with-credentials="true"                            
                        :format="['jpg','jpeg','png','pdf' ]"
                        :max-size="5120"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :disabled="saveFlag"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex; "  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image>
                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item.IDSEQ,item.LSTSEQ,item.FILEPATH,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <i v-if="mainRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                    <i v-else-if="mainRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu" style="margin-left:30px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button @click="saveRec" :disabled="addBool||saveFlag" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  >{{ $LANG('0130', '保存') }}</el-button >
                </span>
            </div>
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>  
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue'  
import repWin from '../datamgt/repWin.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
export default {
    name:'try_report',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '422002',
            fieldIdseq: '422002',
            fieldLstseq: '1',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refqc',
            generatedFixedColumnKeys: ['rownum', 'index', 'oper'],
        })
    ],
    data () {
        return {
            repWin:false,
            repUrl:'',
            mainRow:{},
            promptWin:false,
            addFlag:'create',
            stfgSet:'ALL',
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容')+'...',
            ruleValidate:{},
            selparam:'IDNO',
            txtparam:'',
            selparam2:'',
            txtparam2:'',
            oper2:'like',
 
            comboArr:[],
            goPage:'',
            empArr:[],
            qcData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            chkBool:false, //确认权限
            v_loading:false,
            current:1,
            saveFlag:false,
            deptArr:[],
            allList:[], //询价单集合
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            dataCount:0,
            rowSize:50,
            tabCol:[],
            initCol:[],
            vueCol:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            v_headerRow:{},
            headerSortKey:'',
            headerSortOrder:'',
            queryRequestId:0,
            operArr:[],
            oper:'like',
            v_idseq:this.$cookies.get('idseq'),
            v_rowIndex:'',
            notNull:[],
            stfgBool:true,
            v_formurl:'xuper_auth/getFormGroup', 
            formArr:[],
            v_admin:this.$cookies.get('v_admin') , 
            v_random:'',
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            v_key:'',
            btnWin:false,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_commit :true,
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            fileName:'',
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            delImg:[],
            t_cond:'',
            tryCol:[],
            hrCol:[],
        }
    },
    components: {
        repWin,
        pubWin,
        VeColumnConfigDialog,
    },
    computed: {
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
        subHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 296) + 'px';
        }, 
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    mounted () {
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_HR_DEPT','').then(res=>{
            this.deptArr =res.result
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        this.comSelect()
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','422002','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ // 确认
                    this.chkBool=true
                }
            }
        })    
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','422002','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','422002','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //人员资料
        getBaseData(this.v_url,'CORPID',this.v_corpid ,'ISOUT','N','V_SYS_USER','').then(res=>{
            this.empArr =res.result
        })
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','422002','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#try_report"),
                name: "wave",
            })
            this.getTabCol() //表列集合
            this.getQcList('') //询价单主数据    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        btnSure(obj){
            if (this.v_key=='REFIDNO'){
                Object.assign(this.mainRow,{ REFIDNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'] ,REFDTTM:obj['DTTM'] })     
            }else if (this.v_key=='BIZER'){
                Object.assign(this.mainRow,{ BIZER:obj['EMPNM'],TELNO1:obj['TELNO'] })     
            }else if (this.v_key=='PRODER'){
                Object.assign(this.mainRow,{ PRODER:obj['EMPNM'],TELNO2:obj['TELNO'] })     
            }else if (this.v_key=='QCER'){
                Object.assign(this.mainRow,{ QCER:obj['EMPNM'],TELNO3:obj['TELNO'] })     
            }else if (this.v_key=='TECHER'){
                Object.assign(this.mainRow,{ TECHER:obj['EMPNM'],TELNO4:obj['TELNO'] })     
            }else if (this.v_key=='STAFF'){
                Object.assign(this.mainRow,{ STAFF:obj['EMPNM'] })     
            }
            this.btnWin =false
        },
        inputBtn(row,index, key){   
            this.v_key =key     
            if (key =='REFIDNO'){    
                this.v_random=Math.random()  
                this.v_key =key  
                this.v_table ='v_RD_TRY'
                this.tableCol =this.tryCol
                this.v_key2 =''
                this.v_value2 = ''
                this.t_cond=''
                this.btnWin =true
 
            }else if (key=='BIZER'||key=='PRODER'||key=='QCER'||key=='TECHER'||key=='STAFF' ){
                this.v_random=Math.random()  
                this.v_key =key  
                this.v_table ='V_HR_EMP_STFG'
                this.tableCol =this.hrCol
                this.v_key2 =''
                this.v_value2 = ''
                this.t_cond=''
                this.btnWin =true
            }
        },
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(idseq,lstseq,path,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此附件吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:idseq,LSTSEQ:lstseq,FILEPATH:path}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误')+','+file.name+' '+this.$LANG('1431', '是不正确， 请选择图片或PDF格式')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name+this.$LANG('1561', '文件太大， 不能超出')+'5M'
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }               
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 

        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'422002',p_cond:' and lstseq in (1 )' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //查询附件数据
        qryImgData(idseq){
            this.imgData=[]
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {              
                if (res){
                    this.imgData =res.result
                }
            })
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                 this.saveFlag=false 
            }
            this.addFlag='edit'
            this.mainRow =JSON.parse(JSON.stringify( row ))
            this.qryImgData(row.IDSEQ)
            this.addWin=true  
            this.v_commit =true
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) {   
                this.v_commit =false
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.mainRow,{CORPID:this.v_corpid})), p_table:'TRY_REP',frmid:'422002'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq
                        //3、图片保存
                        for(var k=0;k<this.imgData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                            })
                        }  
                        //图片删除处理
                        for(let k=0;k<this.delImg.length;k++){
                            let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                            }).then(res=>{          
                                //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                    this.$axios({
                                        method: 'post',
                                        url: '/xuper_oss/ftpDelete',
                                        data: {p_path:'/volume1'+v_path},
                                    }).then(res=>{ 
                                        console.log(res.result)
                                    })
                                }
                            })      
                        } 
                        this.addWin =false   
                        this.stfgChange()
                    }else{  
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.saveFlag=false 
            this.mainRow={ 'IDSEQ':'','STFG':'N',DTTM:getDate('day') }
            this.imgData=[]
            this.v_commit =true 
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
 
        //状态变更
        stfgRec(row,val,index,v_comm){
            let v_cond ='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
            if (val =='K') {
                v_cfmdttm =getDate('full')
                v_cfmuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
            }else if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗')+'?',this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'TRY_REP',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        if (val =='X'){
                            this.qcData.splice(index,1)
                        } else{        
                            if (val =='Y'){
                                Object.assign(row,{STFGNM:v_comm ,STFG:val, CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                            }else{
                                Object.assign(row,{STFGNM:v_comm ,STFG:val,APPUSER:v_cfmuser,APPDTTM:v_cfmdttm,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                            }
                        }
                    }    
                })
            }).catch(()=>{})
             
        },
 
 
        //状态查询
        buildToolbarCondition(key, value, operator){
            if (!isVeTableMetadataField(this.initCol, key)) return ''
            if (operator === '!=') return ` and ${key} is null `
            return buildVeTableFieldCondition(this.initCol, key, value, operator)
        },
        stfgChange(){
            this.current =1
            let cond_=this.buildToolbarCondition(this.selparam, this.txtparam, this.oper)
            cond_+=this.buildToolbarCondition(this.selparam2, this.txtparam2, this.oper2)
            cond_+=buildVeTableHeaderCondition(this.initCol, this.v_headerRow)
            if (this.stfgSet!=='ALL'){
               cond_=cond_+' and  stfg=\''+this.stfgSet+'\''
            }
            this.getQcList(cond_)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.qcData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.qcData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.qcData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            
        },
 
        //查询清单 
        getQcList(cond){
            this.v_loading=true
            const requestId = ++this.queryRequestId
            const requestedSortKey =this.headerSortKey || this.selparam
            const sortKey =isVeTableMetadataField(this.initCol, requestedSortKey) ? requestedSortKey : 'IDNO'
            const sortOrder =this.headerSortKey && this.headerSortOrder === 'asc' ? 'asc' : 'desc'
            getTabColOrData(this.v_url,'v_TRY_REP','','','CORPID',this.v_corpid,'','',cond+' order by '+sortKey+' '+sortOrder).then((res) => {
                if (requestId !== this.queryRequestId) return
                this.allList =res.result 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    const table = this.$refs.refqc
                    if (table && typeof table.doLayout === 'function') table.doLayout()
                    this.v_loading=false
                }) 
                this.initPage() 
            }).catch(error => {
                if (requestId !== this.queryRequestId) return
                this.v_loading=false
                this.promptWin=true
                this.prompt=error && error.message ? error.message : this.$LANG('1641', '查询失败')
            })
        },
        rowShow(){
            this.v_headerRow={}
            this.stfgChange()
        },
        sortHeaderColumn(key, edcss){
            if (!isVeTableMetadataField(this.initCol, key)) return
            this.headerSortOrder =this.headerSortKey === key && this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            this.headerSortKey =key
            const direction =this.headerSortOrder === 'asc' ? 1 : -1
            const type =String(edcss || '').toLowerCase()
            this.allList.sort((left, right) => {
                const leftValue =left[key]
                const rightValue =right[key]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined) return -1 * direction
                if (rightValue === null || rightValue === undefined) return direction
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                return String(leftValue).localeCompare(String(rightValue)) * direction
            })
            this.current =1
            this.initPage()
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','422002','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabCol = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        const title =vm.$translate.getColTitle(item, vm.$store.state.lang)
                        const headerSortable =item.SORTABLE === 'N' && item.EDCSS !== 'checkbox'
                        vm.tabCol.push({
                            title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                            sortable: item.SORTABLE,
                        })
                        if (item.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title,
                            type: item.EDCSS === 'checkbox' ? 'check' : item.EDCSS,
                            align: item.align,
                            width: Number(item.width) || 120,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader
                                title={column.title}
                                edcss={item.EDCSS}
                                value={vm.v_headerRow[item.key]}
                                operator={vm.v_headerRow[`#OPER${item.key}`]}
                                showDateOperator={false}
                                sortable={headerSortable}
                                sortOrder={vm.headerSortKey === item.key ? vm.headerSortOrder : ''}
                                options={String(item.EDCSS || '').toLowerCase() === 'select' ? (vm.comboArr[item.key] || []) : []}
                                on-input={(value) => vm.$set(vm.v_headerRow, item.key, value)}
                                on-operator-change={(value) => vm.$set(vm.v_headerRow, `#OPER${item.key}`, value)}
                                on-title-click={() => {
                                    if (headerSortable) vm.sortHeaderColumn(item.key, item.EDCSS)
                                }}
                                on-query={() => vm.stfgChange()}
                            />,
                            renderBodyCell: ({row}) => {
                                if (item.key === 'IDNO') {
                                    return (
                                        <el-link underline={false} on-click={() => vm.repBtn(row)}>
                                            <div style="color:#409eff;border-bottom:1px solid red;font-size:11px">{row[item.key]}</div>
                                        </el-link>
                                    )
                                }
                                if (item.EDCSS === 'checkbox') {
                                    return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]} style="width:100%">&nbsp;</el-checkbox>
                                }
                                return <span>{row[item.key]}</span>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderHeaderCell: ({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link underline={false} on-click={() => vm.rowShow()} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 200,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                <el-link on-click={() => vm.editRec(row, 'Y', rowIndex)} underline={false}>
                                    <span style="font-size:11px;margin-right:5px">{vm.$LANG('0139', '查看')}</span>
                                </el-link>
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link on-click={() => vm.editRec(row, 'N', rowIndex)} underline={false}>
                                        <span style="font-size:11px;margin-right:5px">{vm.$LANG('1639', '编辑')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.chkBool} on-click={() => vm.stfgRec(row, 'K', rowIndex, vm.$LANG('0364', '确认'))} underline={false}>
                                        <span style="font-size:11px;margin-right:5px">{vm.$LANG('0364', '确认')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'K' ? <span>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.chkBool} on-click={() => vm.stfgRec(row, 'N', rowIndex, vm.$LANG('0314', '弃认'))} underline={false}>
                                        <span style="font-size:11px;margin-right:5px">{vm.$LANG('0314', '弃认')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'K' ? <span>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.cfmBool} on-click={() => vm.stfgRec(row, 'Y', rowIndex, vm.$LANG('0134', '审核'))} underline={false}>
                                        <span style="font-size:11px;margin-right:5px">{vm.$LANG('0134', '审核')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'Y' ? <span>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.cfmBool} on-click={() => vm.stfgRec(row, 'K', rowIndex, vm.$LANG('0137', '弃审'))} underline={false}>
                                        <span style="font-size:11px;margin-right:5px">{vm.$LANG('0137', '弃审')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link on-click={() => vm.stfgRec(row, 'X', rowIndex, vm.$LANG('0257', '作废'))} underline={false}>
                                        <span style="font-size:11px">{vm.$LANG('0257', '作废')}</span>
                                    </el-link>
                                </span> : null}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','422005','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tryCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.hrCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .ve-list-page {
        display: flex;
        flex-direction: column;
        height: calc(100% - 32px);
        min-height: 0;
        overflow: hidden;
        background: white;
    }
    .ve-list-page__table {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
    }
    .ve-list-page__table > .vue-table-root {
        height: 100%;
    }
    .ve-list-page__table /deep/ .ve-table,
    .ve-list-page__table /deep/ .ve-table-container {
        height: 100% !important;
        max-height: 100% !important;
    }
    .ve-list-page__pagination {
        flex: 0 0 38px;
        min-height: 38px;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        background: white;
        font-size: 12px;
        padding-top: 3px;
        box-sizing: border-box;
    }
    .item-width  {
        width: 32%;
        height:22px;
    }
    .item-one {
        width: 97%;
        height:88px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
 </style>
 <style lang ="less">
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight: 700 !important;
        padding: 0 !important;
        padding-top: 4px !important;
        text-align: center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-body-cell-class1 {
        height: 20px !important;
        padding: 2px !important;
        color: black !important;
        font-size: 12px !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
 </style>
